<template>
  <div class="about-section">
    <div class="about-section__content">
      <img
        :src="require('assets/images/landing/queropago-white.svg')"
        class="content__logo"
        alt="Quero Pago"
      >
      <img
        :src="require('assets/images/landing/smartphone.png')"
        class="content__smartphone"
        alt="Quero Pago Smartphone"
      >
      <z-button brand="undergraduate" size="medium" class="content__login-cta" @click="goToLogin()">
        Acessar minha conta
      </z-button>
      <div class="content__about">
        <div class="content__about-display">
          <z-display class="about-display__text" size="medium" color="inverted">
            Se tem
            <div class="about__product-name">
              <span class="product-name__text">
                Quero Pago
              </span>
              <img
                :src="require('assets/images/landing/blue-line.svg')"
                alt="Quero Pago Blue Line"
                class="product-name__blue-line"
              >
            </div>,
            <br>
            é fácil demais
          </z-display>
        </div>
        <z-text size="large" color="inverted" class="content__about-description">
          Você paga as suas mensalidades e controla tudo pelo celular.
        </z-text>
        <z-button brand="undergraduate" size="medium" class="content__about-cta" @click="goToLogin()">
          Acessar minha conta
        </z-button>
      </div>
      <div class="content__advantage">
        <div class="content__advantage-title">
          <z-title size="large" color="inverted">
            Sua facul escolheu o Quero Pago?
          </z-title>
          <z-title size="large" color="inverted">
            Aproveita! Porque a vida tá mais fácil
          </z-title>
        </div>
        <z-text size="large" color="inverted" class="content__advantage-description">
          Secretaria? Não! O aluno Quero Pago só precisa de um celular.
        </z-text>
      </div>
      <z-card class="content__advantage-card content__advantage-card--dificult" size="large">
        <img
          class="advantage-card__emoji"
          :src="require('assets/images/landing/smiling-face-with-heart-shaped-eyes.png')"
          alt="Smiling Face"
        >
        <z-title class="advantage-card__title" size="small" color="major">
          Não dá pra complicar, <br>né?
        </z-title>
        <z-text size="medium" color="major">
          Aqui, você paga as mensalidades, confere seu histórico de pagamentos e atualiza os dados.
          Precisou renegociar? É pelo cel também.
        </z-text>
      </z-card>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToLogin() {
      this.$router.push({ name: 'login' });
    },
  },
};
</script>

<style scoped lang="scss">
.about-section {
  background-color: var(--color-primary);
  padding-bottom: var(--space-extra-colossal);
  padding-top:  var(--space-extra-large);

  @media screen and (max-width: $screen-md-max) {
    padding: var(--space-large) var(--space-medium) var(--space-jumbo) var(--space-medium);
  }
}

.about-section__content {
  display: grid;
  grid-column-gap: var(--space-large);
  grid-row-gap: var(--space-jumbo);
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: max-content auto auto;
  margin: 0 auto;
  max-width: 1140px;
  position: relative;
  z-index: 1;

  @media screen and (max-width: $screen-md-max) {
    grid-row-gap: 0;
    grid-template-columns: 100%;
    grid-template-rows: auto;
    justify-items: center;
    max-width: none;
    width: 100%;
  }
}

.content__smartphone {
  grid-column: 8 / 13;
  grid-row: 1 / 3;
  height: 461px;
  justify-self: right;
  margin-right: var(--space-extra-large);

  @media screen and (max-width: $screen-md-max) {
    grid-column: 1;
    grid-row: 3;
    height: 212px;
    justify-self: unset;
    margin-bottom: var(--space-large);
    margin-right: 0;
  }
}

.content__logo {
  grid-column: 1 / 8;
  grid-row: 1;
  height: var(--size-extra-large);
  margin: var(--size-small) 0 var(--size-small) var(--space-extra-large);

  @media screen and (max-width: $screen-md-max) {
    grid-column: 1;
    grid-row: 1;
    height: var(--size-large);
    margin-bottom: var(--space-jumbo);
    margin-left: 0;
    margin-top: 0;
  }
}

.content__about {
  grid-column: 1 / 8;
  grid-row: 2;
  margin-left: var(--space-extra-large);

  @media screen and (max-width: $screen-md-max) {
    grid-column: 1;
    margin-bottom: var(--space-medium);
    margin-left: 0;
    text-align: center;
  }
}

.about__product-name {
  display: inline-block;
  position: relative;
}

.product-name__text {
  position: relative;
  z-index: 1;
}

.product-name__blue-line {
  bottom: 0;
  left: 0;
  position: absolute;
  width: 98%;
  z-index: 0;
}

.content__about-display {
  margin-bottom: var(--space-medium);
}

.content__about-description {
  margin-bottom: var(--space-jumbo);

  @media screen and (max-width: $screen-md-max) {
    margin-bottom: 0;
    text-align: center;
  }
}

.content__about-cta {
  @media screen and (max-width: $screen-md-max) {
    display: none;
  }
}

.content__login-cta {
  display: none;

  @media screen and (max-width: $screen-md-max) {
    display: inline-block;
    grid-column: 1;
    grid-row: 4;
    margin-bottom: var(--space-jumbo);
  }
}

.content__advantage {
  grid-column: 1 / 9;
  grid-row: 3;
  margin-left: var(--space-extra-large);

  @media screen and (max-width: $screen-md-max) {
    grid-column: 1;
    grid-row: 5;
    margin-bottom: var(--space-extra-large);
    margin-left: 0;
  }
}

.content__advantage-title {
  margin-bottom: var(--space-large);

  @media screen and (max-width: $screen-md-max) {
    text-align: center;
  }
}

.content__advantage-description {
  @media screen and (max-width: $screen-md-max) {
    text-align: center;
  }
}

.content__advantage-card {
  width: 100%;
}

.content__advantage-card--dificult {
  grid-column: 9 / 13;
  grid-row: 3;

  @media screen and (max-width: $screen-md-max) {
    grid-column: 1;
    grid-row: 6;
    margin-bottom: var(--space-medium);
  }
}

.advantage-card__emoji {
  height: var(--size-jumbo);
  margin-bottom: var(--space-medium);
}

.advantage-card__title {
  margin-bottom: var(--space-small);
}

@media screen and (max-width: $screen-md-max) {
  .about-display__text {
    text-align: center;
  }
}
</style>
